
 <div class="row logo-container">
   <div class="logo-wrapper" #logo>
     <a target="_blank" [href]="companyWebsite"><img class="logo" [src]="logoImageUrl"></a>
   </div>

   <div class="align-self-center d-flex flex-row flex-grow-1 justify-content-center" *ngIf="!IsUserLoggedIn">
     <span class="client-header">{{clientHeader}}</span>
   </div>

   <div #rightSideLogoDummy></div>

   <div class="align-self-center d-flex flex-row flex-grow-1" *ngIf="IsUserLoggedIn && showActions">
       <div class="actions-wrapper">
           <div [routerLink]="['/inbox']">
             <i class="fas fa-bell icon"></i>
               <label class="text-color-with-no-background">{{'NOTIFICATIONS' | dictionary}}</label>
           </div>


         <div [routerLink]="['/my-profile']" >
           <i class="fas fa-user-circle icon"></i>
           <label class="text-color-with-no-background">
             {{currentUserName || ('MY_PROFILE' | dictionary)}}</label>
         </div>
       </div>
     </div>
 </div>

 <dynamic-modal></dynamic-modal>
 <!-- Dynamic Component Container  -->
 <div class="modal fade star-webportal" id="dynamicComponentContainer" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
     aria-hidden="true">
     <div class="modal-dialog" role="document">
         <div class="modal-content">
             <div class="modal-header" style="padding:10px;background: #77A; color: white;">
                 <h5 class="modal-title" id="exampleModalLabel" style="float:left;font-weight: 400;">{{'EDIT_REASON_DIALOG' | dictionary}}</h5>
             </div>
             <div class="modal-body">
                 <div #parentDynamicComponent></div>
             </div>
         </div>
     </div>
 </div>
